import { render } from "./DatesUpdate.vue?vue&type=template&id=05264ac6&scoped=true"
import script from "./DatesUpdate.vue?vue&type=script&lang=js"
export * from "./DatesUpdate.vue?vue&type=script&lang=js"

import "./DatesUpdate.vue?vue&type=style&index=0&id=05264ac6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05264ac6"]])

export default __exports__